namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_spell_manage, {
		
		Menu: {
			flex: {
				basis: '25rem',
			},
		},
		
		Menu_links: {
			gap: $mol_gap.block,
		},
		
		Level: {
			background: {
				color: $mol_theme.card,
			},
		},
		
	} )
	
}
